import smoothscroll from 'smoothscroll-polyfill'

smoothscroll.polyfill()

document.querySelectorAll('a.arrow').forEach(arrow => {
  const target = arrow.hash
  const handler = ev => {
    ev.preventDefault()
    document.querySelector(target).scrollIntoView({ behavior: 'smooth' })
  }

  arrow.addEventListener('click', handler)
})

document.querySelectorAll('img').forEach(img => {
  const target = img.src
  const handler = ev => {
    window.open(target)
  }
  img.addEventListener('click', handler)
})
